var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99952 1C9.85617 1 11.6368 1.73755 12.9496 3.0504C14.2625 4.36325 15 6.14385 15 8.0005C15 9.85715 14.2625 11.6378 12.9496 12.9506C11.6368 14.2634 9.85617 15.001 7.99952 15.001C6.14288 15.001 4.36227 14.2634 3.04942 12.9506C1.73657 11.6378 0.999023 9.85715 0.999023 8.0005C0.999023 6.14385 1.73657 4.36325 3.04942 3.0504C4.36227 1.73755 6.14288 1 7.99952 1ZM9.04952 5.298C9.56952 5.298 9.99152 4.937 9.99152 4.402C9.99152 3.867 9.56852 3.506 9.04952 3.506C8.52952 3.506 8.10952 3.867 8.10952 4.402C8.10952 4.937 8.52952 5.298 9.04952 5.298ZM9.23252 10.925C9.23252 10.818 9.26952 10.54 9.24852 10.382L8.42652 11.328C8.25652 11.507 8.04352 11.631 7.94352 11.598C7.89815 11.5813 7.86023 11.549 7.83658 11.5068C7.81293 11.4646 7.80511 11.4154 7.81452 11.368L9.18452 7.04C9.29652 6.491 8.98852 5.99 8.33552 5.926C7.64652 5.926 6.63252 6.625 6.01552 7.512C6.01552 7.618 5.99552 7.882 6.01652 8.04L6.83752 7.093C7.00752 6.916 7.20552 6.791 7.30552 6.825C7.35479 6.84268 7.39516 6.87898 7.41797 6.92609C7.44078 6.97321 7.44421 7.02739 7.42752 7.077L6.06952 11.384C5.91252 11.888 6.20952 12.382 6.92952 12.494C7.98952 12.494 8.61552 11.812 9.23352 10.925H9.23252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.14b7d6729804c746e9dc54e9f90115c9.svg";
export { ForwardRef as ReactComponent };